import { createFormConfig, ValidationRules } from "helpers/createFormConfig";
import { TenantFormFieldNames } from "../types/tenantFormFieldNames";
import { TenantGuarantorFormValues } from "../types/tenantGuarantorFormValues";
import { tenantGuarantorValidationRules } from "./tenantGuarantorValidationRules";

const tenantGuarantorFormConfig = createFormConfig<TenantGuarantorFormValues>(
  tenantGuarantorValidationRules as ValidationRules<keyof TenantGuarantorFormValues>,
  {
    [TenantFormFieldNames.Civility]: 'Mr',
  }
);

export { tenantGuarantorFormConfig };
